import { Grid, Paper, Typography } from '@mui/material';
import { FormMonacoEditor, HeadlinePage } from 'components/common';
import { ROUTES } from 'consts';
import { dataModelPolicies } from 'helpers';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useStyle } from './styles';

export default function DataModelViewDumb({ defaultValues }) {
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { reset } = methods;

  const fields = [
    { policy: dataModelPolicies.name, value: defaultValues.name },
    { policy: dataModelPolicies.project, value: defaultValues.project.label },
  ];

  useEffect(() => {
    reset(defaultValues)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <>

      <HeadlinePage
        title={'dataModelView.headline'}
        goBack={ROUTES.DATA_MODEL_LIST}
      />

      <Paper className={classes.paperStyle}>
        <Typography variant="h6" sx={{ padding: '8px 0px' }}>
          {t('dataModelList.form.title')}
        </Typography>

        <Grid container spacing={2}>
          { fields.map((field) => (
            <Grid key={field.policy.id} item xs={12} sm={12} md={6} lg={4}>
              <Typography variant="subtitle1">
                {t(field.policy.label)}
              </Typography>
              <Typography variant="body1">
                {field.value}
              </Typography>
            </Grid>
          ))}


          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormMonacoEditor
              label={dataModelPolicies.additionalVariables.label}
              name={dataModelPolicies.additionalVariables.name}
              language={defaultValues.language}
              methods={methods}
              options= {{
                readOnly: true,
              }}
            />
          </Grid>

        </Grid>
      </Paper>
    </>
  );
}
